module.exports = __webpack_public_path__ + "static/media/Law of Small Numbers.a79f990e.jpg";